import { jsxs as m, jsx as e } from "react/jsx-runtime";
import { s, O as o } from "../../OurPromisesItems-1229c40b.mjs";
const l = (a) => {
  var r;
  return /* @__PURE__ */ m("div", { className: s["our-promises-container"], "data-testid": "our-promises-test-id", "data-pod-name": "commerce", children: [
    /* @__PURE__ */ e("h3", { className: s["our-promises-title-section"], children: a.title }),
    /* @__PURE__ */ e("div", { className: s["our-promises-image-info-container"], children: /* @__PURE__ */ e("div", { className: s["our-promises-image-section"], children: (r = a.ourPromisesdata) == null ? void 0 : r.map((i) => /* @__PURE__ */ e(o, { imagesData: i.imagesData, imageTitle: i.imageTitle }, `${i.imageTitle}`)) }) })
  ] });
};
export {
  l as default
};
//# sourceMappingURL=OurPromises.js.map
